// import React from "react";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./customized-date-picker.scss";
import { useSelector } from "react-redux";
const CustomizedDatePicker = ({ containerClass = "", ...reset }) => {
  const dir = useSelector(({ theme }) => theme.direction);

  return (
    <div className={`customized-date-picker ${containerClass}`}>
      {/* <DatePicker
        placeholderText="dd/mm/yyyy"
        showIcon={true}
        selected={
          reset.value === null ||
          reset.value === undefined ||
          reset.value === ""
            ? new Date()
            : reset.value
        }
        {...reset}
      /> */}
      <input
        type="date"
        {...reset}
        value={
          reset.value === null ||
          reset.value === undefined ||
          reset.value === ""
            ? ""
            : reset.value
        }
        style={{
          textAlign: dir === "rtl" ? "end" : "start",
          verticalAlign: "middle",
        }}
        min={reset.minDate}
        max={reset.maxDate}
      />
    </div>
  );
};

export default CustomizedDatePicker;
